import { authAtom, jotaiStore } from '~/atoms/authAtom';

export const getAuthToken = async () => {
  const auth = jotaiStore.get(authAtom);
  const token = await auth?.auth.getToken({
    template: 'banqora_template',
  });
  return token;
};
